<div class="collection_title" (click)="onOpenBoardsList()">
  <div class="arrow_state_icon" [class.closed_state]="!isVisibleBoards">
    <svg width="18" height="18">
      <use xlink:href="#triangle"></use>
    </svg>
  </div>
  <h3>{{collection.name}}</h3>
  <div class="context_menu" *ngIf="hasPermission$ | async">
    <left-menu-context-menu
      [isOpened]="isContextMenuVisible"
      (open)="onSwitchContextMenu()"
      (close)="onSwitchContextMenu()"
    >
      <p (click)="onToggleLeftMenu()" [routerLink]="appUrls.getUrlCollectionSettings(collection.id)">Edit Collection Settings</p>
      <p (click)="onToggleLeftMenu()" [routerLink]="appUrls.getUrlNewBoard()" [queryParams]="{collectionId: collection.id, goToNewBoard: true, source: 'leftMenu'}" >Add Board to Collection</p>

    </left-menu-context-menu>
  </div>

</div>
<left-board-list *ngIf="isVisibleBoards && visibleBoards.length !== 0"
                 [collection]="collection"
                 [boards]="visibleBoards"
                 [isSubCollection]="true"
></left-board-list>
